import { Navigate, useLocation } from 'react-router-dom'

/**
 * Spec 161 (research D-161-08) — redirige une ancienne adresse vers sa nouvelle place en gardant ses paramètres et son
 * ancre, sans entrée d'historique supplémentaire.
 *
 * Pourquoi pas `<Navigate to="…">` nu : il perd la chaîne de requête. Or `?client=` désigne le client affiché (spec
 * 160) — le perdre ferait afficher le client par défaut au lieu du client demandé, ou au lieu du refus d'accès qu'un
 * client hors périmètre appelle (garde-fou B1).
 */
export function RedirectionConservante({ vers }: { vers: string }) {
  const { search, hash } = useLocation()
  return <Navigate to={`${vers}${search}${hash}`} replace />
}
